import type { SettingDefinition } from '@/types'

export function groupByPrefix(registry: SettingDefinition[]): Record<string, SettingDefinition[]> {
  const groups: Record<string, SettingDefinition[]> = {}
  for (const defn of registry) {
    const prefix = defn.key.split('.')[0]
    if (!groups[prefix]) groups[prefix] = []
    groups[prefix].push(defn)
  }
  return groups
}

export function labelForKey(key: string): string {
  const short = key.split('.').slice(1).join(' ')
  return short.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}
